"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sumItemsFromProps = void 0;
var sumItemsFromProps = function sumItemsFromProps(_ref) {
  var image360 = _ref.image360,
    images = _ref.images,
    videos = _ref.videos;
  var totalItemCount = image360 ? 1 : 0;
  images && (totalItemCount += images.length);
  videos && (totalItemCount += videos.length);
  return totalItemCount;
};
exports.sumItemsFromProps = sumItemsFromProps;